import { fetchWrapper } from "@/_helpers";

const baseUrl = "https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/";

export const vinUSService = {
  getVINInfo,
};

function getVINInfo(VIN) {
  return fetchWrapper.get(`${baseUrl}${VIN}?format=json`);
}
